/* eslint-disable jira/filename-case */

import type { AnalyticsWebClient } from '@jira/platform__observability-product-analytics-web-client-types';
import { initAnalyticsWebClient } from '@jira/platform__observability-product-analytics-web-client/src/getAnalyticsWebClient.tsx';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import getApplicationSolutions from '../get-application-solutions/getApplicationSolutions.tsx';
import getApplicationSubProduct from '../get-application-sub-product/getApplicationSubProduct.tsx';
import getStagingEnvironment from '../get-staging-environment/getStagingEnvironment.tsx';
import { logEmau } from './log-emau/logEmau.tsx';

export interface InitAnalyticsData extends TenantContext {
	workspaceId?: string;
	orgId?: string;
}
/**
 * Initializes the analytics web client with configuration tailored to the user and product environment.
 * It dynamically adjusts settings based on user and organizational details to enhance product analytics.
 */

export const initAnalytics = ({
	cloudId,
	cloudName,
	atlassianAccountId,
	environment,
	locale,
	orgId,
	activationId: workspaceId,
}: InitAnalyticsData): Promise<AnalyticsWebClient> | boolean | undefined =>
	initAnalyticsWebClient({
		tenantId: cloudId,
		...(atlassianAccountId
			? {
					userId: atlassianAccountId,
				}
			: undefined),
		...(orgId && {
			orgId,
		}),
		...(workspaceId && {
			workspaceId,
		}),
		product: 'jira',
		environment:
			environment === 'prod'
				? 'prod'
				: getStagingEnvironment({
						cloudId,
						cloudName,
						environment,
					}),
		callback: logEmau,
		subProduct: getApplicationSubProduct,
		solutions: getApplicationSolutions(),
		locale,
	});
